import { useContext } from "react";
import { PaletteContext } from "@/providers/ThemeProvider";

export function useTheme() {
  const ctx = useContext(PaletteContext);
  if (!ctx) {
    throw new Error("useTheme must be used within ThemeProvider");
  }
  return ctx;
}
